export function parseJsonSafely(text) {
    if (!text) {
        return null;
    }

    try {
        return JSON.parse(text);
    } catch (error) {
        return null;
    }
}

export function createApiError({ response, data, fallback }) {
    const status = response && response.status;
    const serverMessage = data && typeof data === 'object'
        ? (data.message || data.error)
        : null;
    const message = status >= 500
        ? 'A API está temporariamente indisponível. Tente novamente mais tarde.'
        : serverMessage
            || fallback || (response && response.statusText) || 'Não foi possível concluir a operação.';
    const error = new Error(message);

    if (response) {
        error.response = {
            status: response.status,
            data,
        };
    }

    if (status >= 500) {
        error.code = 'API_SERVER_ERROR';
    }

    return error;
}

export function getLoginErrorMessage(error) {
    if (typeof error === 'string') {
        return error === 'Unauthorized' ? 'Login ou senha inválidos.' : error;
    }

    if (error && (error.message === 'Unauthorized' || error.message === 'Unauthenticated')) {
        return 'Login ou senha inválidos.';
    }

    if (error && error.code === 'API_UNAVAILABLE') {
        return error.name === 'AbortError'
            ? 'A API não respondeu no tempo esperado. Tente novamente.'
            : 'Não foi possível conectar à API. Verifique sua conexão e tente novamente.';
    }

    if (error && error.response && error.response.status >= 500) {
        return 'A API está temporariamente indisponível. Tente novamente mais tarde.';
    }

    return (error && error.message) || 'Não foi possível entrar. Tente novamente.';
}
